"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilSignal = void 0;
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = __importStar(require("zod"));
const hil_signal_attributes_js_1 = require("./hil-signal-attributes.js");
const merge_values_js_1 = require("../utils/merge-values.js");
const hil_signal_block_info_js_1 = require("./hil-signal-block-info.js");
const hilSignalSchema = z.object({
    id: z.union([z.string(), z.number()]),
    name: z.string().default(''),
    description: z.string().nullable().default(null),
    isReviewed: z.boolean().default(false),
    attributes: hil_signal_attributes_js_1.HilSignalAttributes.schema.prefault({}),
    direction: z.nativeEnum(sigma_engine_shared_1.SignalDirection).nullable().default(null),
    sigmaModelSignal: z.union([z.string(), z.number()]).nullable().default(null),
    supportedDriveModes: z.array(sigma_engine_shared_1.SignalDriveModeDefinitionSchema).default([]),
    blockInfo: hil_signal_block_info_js_1.HilSignalBlockInfo.schema.nullable().default(null),
    floatingBehavior: z.nativeEnum(sigma_engine_shared_1.SignalFloatingBehavior).nullable().default(null),
    ties: sigma_engine_shared_1.IExternalComponentSchema.array().default([]),
    isCadstromInternal: z.boolean().default(false),
});
const hilSignalDtoSchema = z.object({
    name: z.string().optional(),
    description: z.string().nullable().optional(),
    isReviewed: z.boolean().optional(),
    attributes: hil_signal_attributes_js_1.HilSignalAttributes.dtoSchema.optional(),
    direction: z.nativeEnum(sigma_engine_shared_1.SignalDirection).nullable().optional(),
    sigmaModelSignal: z.union([z.string(), z.number()]).nullable().optional(),
    supportedDriveModes: z.array(sigma_engine_shared_1.SignalDriveModeDefinitionSchema).optional(),
    blockInfo: hil_signal_block_info_js_1.HilSignalBlockInfo.schema.nullable().optional(),
    floatingBehavior: z.nativeEnum(sigma_engine_shared_1.SignalFloatingBehavior).nullable().optional(),
    ties: sigma_engine_shared_1.IExternalComponentSchema.array().optional(),
    isCadstromInternal: z.boolean().optional(),
});
exports.HilSignal = {
    create: (input) => {
        return hilSignalSchema.parse({
            ...input,
            id: input.id ?? (0, cadstrom_shared_1.generateReadableId)(cadstrom_shared_1.CadstromObjectType.Signal, input.name ?? ''),
        });
    },
    merge: (existing, incoming) => ({
        id: existing.id,
        name: (0, merge_values_js_1.mergeValues)(existing.name, incoming.name),
        description: (0, merge_values_js_1.mergeValues)(existing.description, incoming.description),
        isReviewed: (0, merge_values_js_1.mergeValues)(existing.isReviewed, incoming.isReviewed),
        attributes: (0, merge_values_js_1.mergeValues)(existing.attributes, incoming.attributes, hil_signal_attributes_js_1.HilSignalAttributes.merge),
        direction: (0, merge_values_js_1.mergeValues)(existing.direction, incoming.direction),
        sigmaModelSignal: (0, merge_values_js_1.mergeValues)(existing.sigmaModelSignal, incoming.sigmaModelSignal),
        supportedDriveModes: (0, merge_values_js_1.mergeValues)(existing.supportedDriveModes, incoming.supportedDriveModes),
        blockInfo: (0, merge_values_js_1.mergeValues)(existing.blockInfo, incoming.blockInfo),
        floatingBehavior: (0, merge_values_js_1.mergeValues)(existing.floatingBehavior, incoming.floatingBehavior),
        ties: (0, merge_values_js_1.mergeValues)(existing.ties, incoming.ties),
        isCadstromInternal: (0, merge_values_js_1.mergeValues)(existing.isCadstromInternal, incoming.isCadstromInternal),
    }),
    schema: hilSignalSchema,
    dtoSchema: hilSignalDtoSchema,
};
//# sourceMappingURL=hil-signal.js.map